import React, { PureComponent } from 'react';

interface DeskOpeningTimelineObjectProps {
  isFirst: boolean;
  deskOpeningId: number;
  duration: number;
  isInactive?: boolean;
  isSelected?: boolean;
  onClick: (id: number) => void;
  objectLabel?: string;
  isException?: boolean;
}

const DAY_IN_PIXELS = 8;

export class DeskOpeningTimelineObject extends PureComponent<DeskOpeningTimelineObjectProps> {

  getClass = () => {
    let className = this.props.isException ? 'timeline-table-object-secondary ' : 'timeline-table-object ';

    if (this.props.isInactive) className = className.concat('timeline-object-inactive ');
    else if (this.props.isSelected) className = className.concat('timeline-object-selected');
    else className = className.concat('timeline-object-active');

    return className;
  };

  getCellClass = () => {
    let className = '';
    if (this.props.isFirst) className = className.concat('pt-1 ');

    return this.props.isException ? className.concat('adjustment-cell') : className.concat('standard-rate-cell');
  };

  render() {
    return (
      <td className={this.getCellClass()} colSpan={this.props.duration}>
        <div style={{ width: this.props.duration * DAY_IN_PIXELS }} onClick={() => this.props.onClick(this.props.deskOpeningId)} id={String(this.props.deskOpeningId)} role="button" className={this.getClass()}>
          {this.props.objectLabel && (
            <div className="timeline-object-text-container">
              {this.props.objectLabel }
            </div>
          )}
        </div>
      </td>
    );
  }
}
